<template>
	<table class="mb-4 ml-4">
		<thead>
		<td style="width: 6em;">Day</td>
		<td style="width: 6em;">Time from</td>
		<td style="width: 15em;">Task</td>
		<td style="width: 15em;">Person</td>
		<td style="width: 7em;">ETES-ID</td>
		</thead>
		<tr
			v-for="(shift, shiftIdx) in shifts"
			:key="`${shiftIdx}`"
		>
			<td>{{shift.day}}</td>
			<td>{{shift.time}}</td>
			<td>{{shift.task}}</td>
			<td>{{teamMembersById[shift.owner].name}}</td>
			<td>{{shift.owner}}</td>
		</tr>
		<tfoot></tfoot>
	</table>
</template>

<script>
	export default {
		name: 'TeamAgenda',

		data: () => ({
		}),
		props: ['allShiftsList', 'teamMembersById'],
		watch: {
		},
		computed: {
			shifts: function() {
				return this.allShiftsList.filter(s => s.owner && this.teamMembersById[s.owner]).sort((s1, s2) => s1.timeslotIdx > s2.timeslotIdx ? 1 : s1.timeslotIdx < s2.timeslotIdx ? -1 : 0);
			}
		},
		created: function() {
		},
		methods: {
		}

	}
</script>

<style scoped>
	thead {
		display:table-header-group
	}
	tfoot {
		display:table-footer-group
	}
	tr {
		page-break-inside:avoid;
	}
	tr:nth-child(even) {
		background: #EEE
	}
</style>
